import { useCallback, useEffect } from "react";
import { MockPDA } from "./MockPDA";

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer'
import { isPda, registerPdaScanResultListener, unregisterPdaScanResultListener } from "utils/appRuntime";
import { triggerScanFeedback } from "../../../utils/pda/scanFeedbackUtils";

export type PdaScanEvent = {
    id: string;
    seq: number;
    code: string;
    ts: number;
};

interface PDAState {
    scanResult: string;
    setScanResult: (scanResult: string) => void;
    scanQueue: PdaScanEvent[];
    scanSeq: number;
    queueVersion: number;
    pumpTick: number;
    enqueueScan: (code: string) => void;
    takeNextScan: () => PdaScanEvent | null;
    setPumpTick: () => void;
    clearQueue: () => void;
}

const usePDAStore = create<PDAState>()(
    immer((set, get) => ({
        // 默认状态
        scanResult: '',
        setScanResult: async (scanResult: string) => {
            set({ scanResult });
            await new Promise(resolve => setTimeout(resolve, 1000));
            set({ scanResult: '' });
        },
        scanQueue: [],
        scanSeq: 0,
        queueVersion: 0,
        pumpTick: 0,
        enqueueScan: (code: string) => {
            const trimmed = (code ?? '').trim();
            if (!trimmed) return;
            const nextSeq = get().scanSeq + 1;
            const event: PdaScanEvent = {
                id: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
                seq: nextSeq,
                code: trimmed,
                ts: Date.now(),
            };
            set((state) => {
                state.scanSeq = nextSeq;
                state.scanQueue.push(event);
                state.queueVersion += 1;
            });
        },
        takeNextScan: () => {
            const head = get().scanQueue[0];
            if (!head) return null;
            set((state) => {
                state.scanQueue.shift();
                state.queueVersion += 1;
            });
            return head;
        },
        setPumpTick: () => {
            set((state) => {
                state.pumpTick += 1;
            });
        },
        clearQueue: () => {
            set((state) => {
                state.scanQueue = [];
            });
        },
    }))
);

export const useScanResult = () => {
    return usePDAStore(state => state.scanResult);
}

export const usePdaScanQueueVersion = () => usePDAStore(state => state.queueVersion);
export const usePdaPumpTick = () => usePDAStore(state => state.pumpTick);
export const useEnqueuePdaScan = () => usePDAStore(state => state.enqueueScan);
export const useTakeNextPdaScan = () => usePDAStore(state => state.takeNextScan);
export const useSetPumpTick = () => usePDAStore(state => state.setPumpTick);
export const useClearPdaScanQueue = () => usePDAStore(state => state.clearQueue);


const RealPDA = ({ setScanResult }: { setScanResult: (scanResult: string) => void }) => {
    const enqueueScan = useEnqueuePdaScan();
    const padScanResultListener = useCallback((scanResult: string) => {
        triggerScanFeedback();
        enqueueScan(scanResult);
        if (setScanResult) {
            setScanResult(scanResult);
        }
    }, [enqueueScan, setScanResult]);

    useEffect(() => {
        registerPdaScanResultListener(padScanResultListener);
        return () => {
            unregisterPdaScanResultListener(padScanResultListener);
        }
    }, [padScanResultListener]);
    return (
        <div className="w-full h-full">
            
        </div>
    );
};

export const Pda = () => {
    const setScanResult = usePDAStore(state => state.setScanResult);
    useEffect(() => {
        const resetScanResult = async () => {
            await setScanResult("");
        }
        resetScanResult();
    }, [setScanResult]);


    return (
        <div className="w-full h-full">
            {isPda() ? <RealPDA setScanResult={setScanResult} /> : <MockPDA onScanSuccess={setScanResult} />}
        </div>
    );
};